module.exports = __webpack_public_path__ + "img/antes_despues_311.04dd28a4.png";